import React, { useMemo } from "react";

import {
  RichText,
  SubscribeForm,
  SanityRichText,
  Footer as UIFooter,
} from "@bared/ui";

import { useSite } from "~/hooks/useSite";
import { useRouteLoaderData } from "~/hooks/useRouteLoaderData";

export function Footer() {
  const { navConfig } = useRouteLoaderData("routes/$site");

  const navMenu = useMemo(() => {
    return navConfig?.menus.find((menu) => "footer" === menu.id) ?? null;
  }, [navConfig]);

  return <UIFooter navMenu={navMenu} subscribeForm={<FooterSubscribeForm />} />;
}

function FooterSubscribeForm() {
  const site = useSite();

  const { settingSubscribe } = useRouteLoaderData("root");

  if (!settingSubscribe) return null;

  return (
    <SubscribeForm
      siteHandle={site.handle}
      titleContent={
        <RichText>
          <h3>{settingSubscribe.emailTitle}</h3>
          <SanityRichText value={settingSubscribe.emailContent} />
        </RichText>
      }
    />
  );
}
